import { useCallback, useEffect, useRef, useState } from 'react'
import { useGetFieldMappingQuery, usePutFieldMappingMutation } from '../../api/contactApiSlice';
import ImportTable from './Table/ImportTable';
import { FieldSettingsModal } from '../../components/FormBuilder/FieldSettings/FieldSettingsModal';
import { DEFAULT_BASIC_CONFIG } from '../../types/types';
import { createNewField } from '../../components/FormBuilder/FieldSettings/fieldSettingsHelper';
import { useCreateCustomFieldTemplateMutation } from '../../api/formsApiSlice';
import { useToast } from '../../components/toast/ToastContext';
import CrossIcon from '../../assets/icons/CrossIcon';
import { useTheme } from '../../middleware/ThemeContext';
import ViewIcon from '../../assets/icons/ViewIcon';
import { Button } from '../../components/form/Button';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { LoadingSpinner } from '../ui/LoadingSpinner';
import { debounce } from 'lodash';
import InfoIcon from '../../assets/icons/InfoIcon';
import StyledText from '../../components/StyledComponents/StyledText';


interface RowData {
    import: boolean;
    fileColumn: string;
    preview: string;
    mappedField: { label: string; value: string } | null;
}

const FieldMapping = () => {
    const { id, scopeId } = useParams(); // ✅ id + scopeId from URL

    const location = useLocation();
    // const { scopeId } = location.state || {}; // destructure from state    

    const navigate = useNavigate();
    const { data: mappingData, refetch, isLoading, isFetching } = useGetFieldMappingQuery(id);
    const [fieldNameVal, setFieldNameVal] = useState<string | undefined>('');
    const [previewData, { isLoading: isSaving }] = usePutFieldMappingMutation();
    const [showNewFieldModal, setShowNewFieldModal] = useState(false);
    const [createFieldTemplate] = useCreateCustomFieldTemplateMutation();
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const showToast = useToast();
    const { theme } = useTheme();
    const [isLoadingMapping, setIsloadingMapping] = useState(false);
    const [isAutoSaving, setIsAutoSaving] = useState(false);
    const [payload, setPayload] = useState<any[]>([]);
    const [isPreviewBtn, setIsPreviewBtn] = useState(false);

    const anySelected = payload.some(r => r.import);
    const allMapped = payload
        .filter(r => r.import)
        .every(r => Boolean(r.mappedField));
    const canPreview = anySelected && allMapped;


    // const handleSubmit = () => {
    //     const filteredPayload = payload.filter((r) => r.import);

    //     const rowsObject = filteredPayload.reduce((acc, row) => {
    //         acc[row.fileColumn] = row?.mappedField?.value;
    //         return acc;
    //     }, {} as Record<string, string>);

    //     let finalPayload = {
    //         id: id,
    //         updatedMapping: rowsObject
    //     }
    //     previewData(finalPayload)
    //         .then((res) => {
    //             navigate(`/home/preview`, { state: res });
    //         }).catch((err) => {
    //             showToast('Error', 'Failed to save mapping', 'error');
    //         })
    // };

    // const debouncedSave = useCallback(
    //     debounce((rows: RowData[]) => {
    //         const filteredPayload = payload.filter((r) => r.import);

    //         const rowsObject = filteredPayload.reduce((acc, row) => {
    //             acc[row.fileColumn] = row?.mappedField?.value;
    //             return acc;
    //         }, {} as Record<string, string>);

    //         let finalPayload = {
    //             id: id,
    //             updatedMapping: rowsObject
    //         }
    //         previewData(finalPayload)
    //             .then((res) => {
    //                 // navigate(`/home/preview`, { state: res });
    //             }).catch((err) => {
    //                 showToast('Error', 'Failed to save mapping', 'error');
    //             })
    //     }, 500),
    //     [fieldOptions, id, previewData]
    // );

    const handleSubmit = () => {
        setIsloadingMapping(true);
        const filtered = payload.filter(r => r.import);
        const rowsObject = filtered.reduce((acc, row) => {
            if (row.mappedField?.value) {
                acc[row.fileColumn] = row.mappedField.value;
            }
            return acc;
        }, {} as Record<string, string>);

        const finalPayload = {
            id: id!,
            updatedMapping: rowsObject
        };

        // ✅ Submit wali call — navigate with response
        previewData(finalPayload)
            .then((res: any) => {
                setIsloadingMapping(false);
                navigate('/home/preview', { state: res }); // ✅ res bhejo
            })
            .catch(() => {
                setIsloadingMapping(false);
                showToast('Error', 'Failed to save mapping', 'error');
            });
    };

    const isPayloadChanged = (prev: RowData[], next: RowData[]) => {
        if (prev.length !== next.length) return true;

        for (let i = 0; i < next.length; i++) {
            // Compare import status
            if (prev[i].import !== next[i].import) return true;

            // Compare mappedField only if import is true
            if (next[i].import) {
                const prevVal = prev[i].mappedField?.value;
                const nextVal = next[i].mappedField?.value;
                if (prevVal !== nextVal) return true;
            }
        }
        return false;
    };

    // const handlePayloadChange = useCallback(
    //     debounce((rows: RowData[]) => {
    //         // Skip if no real change
    //         if (lastPayloadRef.current && !isPayloadChanged(lastPayloadRef.current, rows)) {
    //             return;
    //         }

    //         lastPayloadRef.current = rows;

    //         const filtered = rows.filter(r => r.import);
    //         const allMapped = filtered.every(r => r.mappedField);

    //         // Only call if there's something to save
    //         if (filtered.length > 0 && allMapped) {
    //             const rowsObject = filtered.reduce((acc, row) => {
    //                 if (row.mappedField) {
    //                     const option = fieldOptions.find(opt => opt.accessKey === row?.mappedField?.value);
    //                     if (option) {
    //                         acc[row.fileColumn] = option.accessKey;
    //                     }
    //                 }
    //                 return acc;
    //             }, {} as Record<string, string>);

    //             previewData({ id, updatedMapping: rowsObject }).catch(() => {
    //                 // optional error handling
    //             });
    //         }
    //     }, 500),
    //     [fieldOptions, id, previewData]
    // );

    const debouncedPreviewSave = useCallback(
        debounce((payloadData: { id: string; updatedMapping: Record<string, string> }) => {
            setIsAutoSaving(true); // ✅ Start saving indicator
            previewData(payloadData).then(() => {
                refetch();
            }).catch(() => {
            }).finally(() => {
                setIsAutoSaving(false); // ✅ Start saving indicator
            });
        }, 500),
        [previewData]
    );

    // Cleanup
    useEffect(() => {
        return () => {
            debouncedPreviewSave.cancel();
        };
    }, [debouncedPreviewSave]);

    // const handlePayloadChange = useCallback((rows: RowData[]) => {
    //     setPayload(rows);
    //     if (!id) {
    //         console.warn('FieldMapping: id is missing, cannot save mapping');
    //         return;
    //     }
    //     // 2. Now trigger debounced save with fresh dependencies
    //     const filteredPayload = rows.filter((r) => r.import);
    //     // const allMapped = filteredPayload.every(r => r.mappedField);

    //     if (filteredPayload.length > 0) {
    //         // Build payload using CURRENT fieldOptions (not stale)

    //         const rowsObject = filteredPayload.reduce((acc, row) => {
    //             acc[row.fileColumn] = row?.mappedField?.value;
    //             return acc;
    //         }, {} as Record<string, string>);

    //         // Debounced save with latest payload
    //         debouncedPreviewSave({ id, updatedMapping: rowsObject });
    //     }
    // }, [fieldOptions, id, debouncedPreviewSave]);

    // const handlePayloadChange = useCallback((rows: RowData[]) => {
    //     setPayload(rows);

    //     if (!id) {
    //         console.warn('FieldMapping: id is missing');
    //         return;
    //     }

    //     const filtered = rows.filter(r => r.import);
    //     if (filtered.length === 0) return;

    //     const rowsObject = filtered.reduce((acc, row) => {
    //         if (row.mappedField) {
    //             // fieldOptions se accessKey verify karein
    //             const option = fieldOptions.find(opt => opt.accessKey === row?.mappedField?.value);
    //             if (option) {
    //                 acc[row.fileColumn] = option.accessKey;
    //             }
    //         }
    //         return acc;
    //     }, {} as Record<string, string>);

    //     debouncedPreviewSave({ id, updatedMapping: rowsObject });
    // }, [fieldOptions, id, debouncedPreviewSave]);

    const handlePayloadChange = useCallback((rows: RowData[]) => {
        setPayload(rows);

        if (!id) return;

        const rowsObject = rows
            .filter(row => row.import)
            .reduce((acc, row) => {
                if (row.mappedField?.value) {
                    acc[row.fileColumn] = row.mappedField.value;
                }
                return acc;
            }, {} as Record<string, string>);

        if (Object.keys(rowsObject).length > 0) {
            debouncedPreviewSave({ id, updatedMapping: rowsObject });
        }
    }, [id, debouncedPreviewSave]);



    // useEffect(() => {
    //     return () => debouncedSave.cancel();
    // }, [debouncedSave]);

    // useEffect(() => {
    //     if (payload.length > 0) {
    //         debouncedSave(payload);
    //     }
    // }, [payload, debouncedSave]);

    // const handleSubmit = () => {
    //     navigate('/home/preview');
    // };
    const isButtonDisabled = isLoadingMapping || !canPreview || isSaving || isFetching || isAutoSaving;
    return (
        <div className="p-3">
            <ImportTable
                title='Review the mapping of your fields'
                subHeading={`We've mapped the columns in your file`}
                columns={mappingData?.columns || []}
                previewRows={mappingData?.previewRows || []}
                suggestedMapping={mappingData?.suggestedMapping || []}
                // fieldOptions={data?.options || []}
                // onChange={(rows) => setPayload(rows)}
                onChange={handlePayloadChange}
                addNewField={(inputValue) => {
                    setFieldNameVal(inputValue);
                    setShowNewFieldModal(true)
                }}
                isLoading={isLoading}
                isFetching={isFetching}
                scopeId={scopeId}
            // fieldOptions={fieldOptions}
            // onFieldSearch={handleFieldSearch}
            // onLoadMoreFields={handleLoadMoreFields}
            // isFetchingFields={isFetchingFields || isLoadingFields}
            // hasMore={fieldOptions.length < (fieldsData?.totalCount ?? 0)}
            />

            <FieldSettingsModal
                config={DEFAULT_BASIC_CONFIG}
                show={showNewFieldModal}
                onHide={() => setShowNewFieldModal(false)}
                onSave={() => setShowNewFieldModal(false)}
                fieldName={fieldNameVal}
                fieldScope={scopeId ? String(scopeId) : ''}
                onSaveForCreate={(fieldType, fieldName, fieldScope, config, accessKey) => {
                    createNewField(
                        fieldType,
                        fieldName,
                        fieldScope,
                        config,
                        accessKey,
                        createFieldTemplate,
                        setRefreshTrigger,
                        showToast,
                        () => { setShowNewFieldModal(false); refetch(); }
                    );
                }}
                isCreating
            />
            {isAutoSaving && payload?.length > 0 && !isLoadingMapping ? <div className='d-flex align-items-center gap-2 justify-content-end pe-4 pt-3 pb-1 '>
                <InfoIcon color={theme?.CorporateTheme?.colors?.primary} size={16} />
                <StyledText fontSize='13px' fontWeight={600} textColor={theme?.CorporateTheme?.colors?.textSecondary}>Saving mapping… Please wait.</StyledText>
            </div> : null}
            <div className='d-flex justify-content-end gap-2 pe-4 pt-2'>
                <Button
                    theme={theme}
                    btnBg={theme?.CorporateTheme?.colors?.filterBG}
                    color={theme?.CorporateTheme?.colors?.textSecondary}
                    type="button"
                    $variant="customButton"
                    className="px-3"
                    onClick={() => navigate('/home/imports')}
                >
                    <CrossIcon />
                    Cancel
                </Button>
                <Button
                    theme={theme}
                    btnBg={theme?.CorporateTheme?.colors?.primary}
                    color={theme?.CorporateTheme?.colors?.background}
                    type="button"
                    $variant="customButton"
                    className={`px-3`}
                    onClick={handleSubmit}

                    disabled={isButtonDisabled}
                >
                    {isLoadingMapping ? <LoadingSpinner size='16px' color={theme?.CorporateTheme?.colors?.background} /> : <ViewIcon color={theme?.CreateFormTheme?.colors?.background} />}
                    Preview
                </Button>
            </div>
        </div>
    )
}

export default FieldMapping
